import { Calendar, Package, Heart } from "lucide-react";
import { motion } from "framer-motion";

const steps = [
  {
    icon: Calendar,
    step: "01",
    title: "Check Your Date",
    description: "Tell us your wedding date and we'll confirm availability instantly.",
  },
  {
    icon: Package,
    step: "02",
    title: "Pick Your Package",
    description: "Choose from our simple packages. Payment plans available for every budget.",
  },
  {
    icon: Heart,
    step: "03",
    title: "Relive Your Day",
    description: "Receive your beautifully edited photos and films to treasure forever.",
  },
];

export function HowItWorks() {
  return (
    <section className="section-padding">
      <div className="container-wide">
        <div className="text-center">
          <h2 className="font-serif text-3xl font-semibold text-foreground md:text-4xl">
            3 Simple Steps
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Booking your wedding photography has never been easier.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {steps.map((item, index) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative text-center"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="absolute left-1/2 top-12 hidden h-0.5 w-full bg-gradient-to-r from-primary/50 to-transparent md:block" />
              )}
              
              <div className="relative mx-auto flex h-24 w-24 items-center justify-center">
                <div className="absolute inset-0 rounded-full bg-primary/10" />
                <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-primary text-primary-foreground">
                  <item.icon className="h-7 w-7" />
                </div>
                <span className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-secondary font-semibold text-secondary-foreground text-sm">
                  {item.step}
                </span>
              </div>
              
              <h3 className="mt-6 font-serif text-xl font-semibold text-foreground">
                {item.title}
              </h3>
              <p className="mt-2 text-muted-foreground">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}